import { render, staticRenderFns } from "./leecheros.vue?vue&type=template&id=70cdc957&"
import script from "./leecheros.vue?vue&type=script&lang=js&"
export * from "./leecheros.vue?vue&type=script&lang=js&"
import style0 from "./leecheros.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports